<template>
  <apollo-query
          :query='getRecorderPostQuery'
          class='grow flex flex-row'
          :variables='{id}'>
      <template v-slot="{ result: { error, data }, isLoading, query }">

        <loading v-if='isLoading' />

        <apollo-query v-if='!isLoading'
                      :query='getGameQuery'
                      class='grow flex flex-row'
                      :variables='{id:data.getPost.game}'>

          <template v-slot="{ result: { error, data }, isLoading, query }">

            <loading v-if='isLoading' />

            <runner-game ref='runnerGame'
                         v-if='!isLoading'
                         :gamedata='getGamedata(data.getGame)'
                         :user='pbcUser'
                         class='w-full h-full'
                         :data='{}'
                         :enable-watermark='watermarked'
                         :override-aspect='overrideAspect'
                         @game-started='onGameStarted'
                         @looped='onLooped'
                         />
          </template>

        </apollo-query>

    </template>
  </apollo-query>
</template>
<script>
import Gamedata from '@edit/tree/gamedata.js';
import ComponentLazyLoader from '@/lazyloader.js';
const {componentLoadingState, fn:RunnerGame}  = ComponentLazyLoader(() => import(/* webpackChunkName: "play" */ '@/play/components/RunnerGame.vue'));
import { ApolloQuery } from 'vue-apollo'
import { getRecorderPostQuery, getGameQuery } from '@/gql/Queries.js';
export default {
  mounted() {
    console.log('[REC] recorder mounted');
  },
  data() {
    const id = this.$route.params.id;
    const overrideAspect = this.$route.query.aspect;
    const watermarked = (this.$route.query.watermarked||'').toLowerCase() !== 'false';
    return {
      id,
      getRecorderPostQuery,
      getGameQuery,
      overrideAspect,
      pbcUser: {
        id: 'cheese'
      },
      watermarked
    }
  },
  methods:{
    getGamedata(in_gamedata) {
      const gamedata = new Gamedata(JSON.parse(in_gamedata));
      return gamedata.gamedata;
    },
    onGameStarted(state) {
      if (this.gameStarted) {
        return;
      }
      console.log('game state', state);
      if (window.puppeteerOnPlaying) {
        window.puppeteerOnPlaying();
      }

      this.$refs.runnerGame.app.stop();
      this.timeStart = Date.now();

      window.runTick = this.animationStep.bind(this);

      // workaround for first couple of frames being blank
      this.gameStarted = true;

      runTick(30);
      runTick(30);

    },
    onLooped() {
      console.log('loop');
      if (window.puppeteerOnLooped) {
        window.puppeteerOnLooped();
      }
    },
    animationStep(dt) {
      this.$refs.runnerGame.tickFunction(dt);
      this.$refs.runnerGame.app.renderer.render(this.$refs.runnerGame.app.stage);

      this.$refs.runnerGame.app.stop();
    }
  },
  components: {
    ApolloQuery,
    RunnerGame
  }
}
</script>

